import React, { useState, useEffect } from "react";
import { StaticSelectInput } from "../../constant/SelectInput";
import {  roleOptionsList } from "../../../utils";
import { createUserApi, getDivisionListApi } from "../../../services/UserService";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useNavigate } from "react-router-dom";

const AddUser = () => {

  const documentPermission = { create: false, review: false, approve: false, issue: false }
  const testEvaluationPermission = { create: false, review: false, approve: false, issue: false }
  const auditPermission = { create: false, approve: false }
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    password: "",
    phoneNumber: "",
    role: "",
    division: "",
    document_permission: documentPermission,
    audit_permission: auditPermission,
    test_evaluation_permission: testEvaluationPermission,
  });

  const [passwordVisible, setPasswordVisible] = useState(false);
  const navigate = useNavigate();
  const [isSubmitLoading, setIsSubmitLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const [divisionOptions, setDivisionOptions] = useState([]); 

  useEffect(() => {
    if (formData.role === "Auditor") {
      getDivisionListApi()
        .then((response) => {
          setDivisionOptions(response.data.data);
        })
        .catch((error) => {
          console.error("Failed to fetch divisions:", error);
        });
    }
  }, [formData.role]);




  const handleChange = (e) => {
    const { name, value } = e.target;
    setErrors((prevErrors) => ({ ...prevErrors, [name]: "" }));
    setFormData((prevDataInput) => ({ ...prevDataInput, [name]: value }));
  };



  const handleSelectChange = (name, value) => {
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handlePasswordToggle = () => {
    setPasswordVisible((prevState) => !prevState);
  };

  const handlePermissionChange = (permissionName, action, value) => {
    setFormData((prevData) => {
      const updatedSpecficPermissions = { ...prevData[permissionName] };
      updatedSpecficPermissions[action] = value
      return { ...prevData, [permissionName]: updatedSpecficPermissions };
    });
  };

  const handleSelectAllPermissionChange = (permissionName, value) => {
    setFormData((prevData) => {
      const newUpdatedPerm = {}
      Object.keys(prevData[permissionName]).forEach(key => {
        newUpdatedPerm[key] = value
      });
      return { ...prevData, [permissionName]: newUpdatedPerm };
    });
  };

  const validateForm = () => {
    let formErrors = {};
    const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%?&])[A-Za-z\d@$!%?&]{8,}$/;
    if (!formData.firstName) formErrors.firstName = "First name is required";
    if (!formData.lastName) formErrors.lastName = "Last name is required";
    if (!formData.email) {
      formErrors.email = "Email is required";
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      formErrors.email = "Invalid email format";
    }
    if (!formData.password) {
      formErrors.password = "Password is required";
    } else if (!passwordRegex.test(formData.password)) {
      formErrors.password =
        "Password must contain at least 8 characters, including an uppercase letter, a lowercase letter, a number, and a special character";
    }
    if (!formData.phoneNumber) {
      formErrors.phoneNumber = "Phone number is required";
    } else if (!/^\d{10}$/.test(formData.phoneNumber)) {
      formErrors.phoneNumber = "Invalid phone number";
    }
    if (!formData.role) formErrors.role = "Role is required";
    setErrors(formErrors);
    return Object.keys(formErrors).length === 0;
  };

  const handleSubmit = async () => {
    console.log("clicked")
    if (validateForm()) {
      try {
        setIsSubmitLoading(true);
        const response = await createUserApi(formData);
        setErrors({});
        navigate("/user");
        toast.success(response.data.message);
      } catch (error) {
        toast.error(error.response.data.message);
      }
      finally {
        setIsSubmitLoading(false);
      }
    };
  }

  const handleCancel = () => {
    setFormData({
      firstName: "",
      lastName: "",
      email: "",
      password: "",
      phoneNumber: "",
      role: "",
      division: "",
      document_permission: documentPermission,
      audit_permission: auditPermission,
      test_evaluation_permission: testEvaluationPermission,
    });
    setErrors({});

    navigate("/user");
  };

  return (
    <div className="container-fluid">
      <div className="row px-sm-2 px-0">
        <div className="col-xl-12">
          <div className="card px-sm-3 px-1">
            <div className="card-body">
              <h3 className="text-center mb-3">User Form</h3>
              <form>
                <div className="row mb-2">
                  {/* First Name */}
                  <div className="col-md-6">
                    <div className="form-group mb-3">
                      <label className="form-label">First Name<span className="text-danger">*</span></label>
                      <input
                        type="text"
                        name="firstName"
                        className="form-control"
                        placeholder="Enter First Name"
                        value={formData.firstName}
                        onChange={handleChange}
                      />

                      {errors.firstName && <div className="text-danger">{errors.firstName}</div>}

                    </div>
                  </div>

                  {/* Last Name */}
                  <div className="col-md-6">
                    <div className="form-group mb-3">
                      <label className="form-label">Last Name<span className="text-danger">*</span></label>
                      <input
                        type="text"
                        name="lastName"
                        className="form-control"
                        placeholder="Enter Last Name"
                        value={formData.lastName}
                        onChange={handleChange}
                      />

                      {errors.lastName && <div className="text-danger">{errors.lastName}</div>}
                    </div>
                  </div>

                  {/* Email */}
                  <div className="col-md-6">
                    <div className="form-group mb-3">
                      <label className="form-label">Email<span className="text-danger">*</span></label>
                      <input
                        type="email"
                        name="email"
                        placeholder="Enter Email"
                        value={formData.email}
                        onChange={handleChange}
                        className="form-control"
                      />
                      {errors.email && <div className="text-danger">{errors.email}</div>}
                    </div>
                  </div>

                  {/* Password */}
                  <div className="col-md-6">
                    <div className="form-group mb-3">
                      <label className="form-label">
                        Password<span className="text-danger">*</span>
                      </label>

                      <div style={{ position: "relative" }}>
                        <input
                          type={passwordVisible ? "text" : "password"}
                          name="password"
                          placeholder="Enter Password"
                          value={formData.password}
                          onChange={handleChange}
                          className="form-control"
                          autoComplete="new-password"
                          style={{ paddingRight: "2.5rem" }}
                        />
                        <span
                          onClick={handlePasswordToggle}
                          style={{
                            position: "absolute",
                            right: "10px",
                            top: "50%",
                            transform: "translateY(-50%)",
                            cursor: "pointer",
                          }}
                        >
                          <i className={passwordVisible ? "fa fa-eye-slash" : "fa fa-eye"}></i>
                        </span>
                      </div>
                      {errors.password && <div className="text-danger">{errors.password}</div>}

                    </div>
                  </div>

                  {/* Phone Number */}
                  <div className="col-md-6">
                    <div className="form-group mb-3">
                      <label className="form-label">Phone Number<span className="text-danger">*</span></label>
                      <input
                        type="text"
                        name="phoneNumber"
                        placeholder="Enter Phone Number"
                        value={formData.phoneNumber}
                        onChange={handleChange}
                        className="form-control"
                      />

                      {errors.phoneNumber && <div className="text-danger">{errors.phoneNumber}</div>}

                    </div>
                  </div>

                  {/* Role Select */}
                  <div className="col-md-6">
                    <div className="form-group mb-3">
                      <StaticSelectInput
                        optionsList={roleOptionsList}
                        setParentInputValue={handleSelectChange}
                        name="role"
                        value={formData.role}
                        isClearable
                        placeholder="Choose Role"
                        label="Role"
                        className="role-select"
                        isRequired
                      />
                      {errors.role && <div className="text-danger">{errors.role}</div>}
                    </div>
                  </div>
                  {formData.role == "Auditor" && (
                    <div className="col-md-6">
                      <div className="form-group mb-3">
                        <StaticSelectInput
                          optionsList={divisionOptions.map((division) => ({
                            value: division.id,  
                            label: division.name 
                          }))}
                          setParentInputValue={handleSelectChange}
                          name="division"
                          value={formData.division}
                          isClearable
                          is_multi={true}
                          placeholder="Choose Division"
                          label="Division"
                          className="role-select"
                          isRequired
                        />
                      </div>
                    </div>
                  )}
                </div>

                {/* Permissions Table */}
                <div className="form-group">
                  <label className="form-label">Permissions</label>
                  <table className="table table-bordered">
                    <thead>
                      <tr>
                        <th>Permission</th>
                        <th>Create</th>
                        <th>Review</th>
                        <th>Approve</th>
                        <th>Issue</th>
                        <th>Select All</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>Document Permission</td>
                        {["create", "review", "approve", "issue"].map((action) => (
                          <td key={action}>
                            {Object.keys(documentPermission).includes(action) ?
                              <div className="form-check custom-checkbox">
                                <input
                                  type="checkbox"
                                  className="form-check-input"
                                  value={action}
                                  checked={formData.document_permission[action]}
                                  onChange={(e) =>
                                    handlePermissionChange("document_permission", action, e.target.checked)
                                  }
                                />
                              </div>
                              : null
                            }
                          </td>
                        ))}
                        <td>
                          <div className="form-check custom-checkbox">
                            <input
                              type="checkbox"
                              className="form-check-input"
                              checked={Object.values(formData["document_permission"]).every((val) => val)}
                              onChange={(e) =>
                                handleSelectAllPermissionChange("document_permission", e.target.checked)
                              }
                            />
                          </div>
                        </td>
                      </tr>

                      <tr>
                        <td>Audit Permission</td>
                        {["create", "review", "approve", "issue"].map((action) => (
                          <td key={action}>
                            {Object.keys(auditPermission).includes(action) ?
                              <div className="form-check custom-checkbox">
                                <input
                                  type="checkbox"
                                  className="form-check-input"
                                  value={action}
                                  checked={formData.audit_permission[action]}
                                  onChange={(e) =>
                                    handlePermissionChange("audit_permission", action, e.target.checked)
                                  }
                                />
                              </div>
                              : null
                            }
                          </td>
                        ))}
                        <td>
                          <div className="form-check custom-checkbox">
                            <input
                              type="checkbox"
                              className="form-check-input"
                              checked={Object.values(formData["audit_permission"]).every((val) => val)}
                              onChange={(e) =>
                                handleSelectAllPermissionChange("audit_permission", e.target.checked)
                              }
                            />
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td>Test/Evaluation Permission</td>
                        {["create", "review", "approve", "issue"].map((action) => (
                          <td key={action}>
                            {Object.keys(testEvaluationPermission).includes(action) ?
                              <div className="form-check custom-checkbox">
                                <input
                                  type="checkbox"
                                  className="form-check-input"
                                  value={action}
                                  checked={formData.test_evaluation_permission[action]}
                                  onChange={(e) =>
                                    handlePermissionChange("test_evaluation_permission", action, e.target.checked)
                                  }
                                />
                              </div>
                              : null
                            }
                          </td>
                        ))}
                        <td>
                          <div className="form-check custom-checkbox">
                            <input
                              type="checkbox"
                              className="form-check-input"
                              checked={Object.values(formData["test_evaluation_permission"]).every((val) => val)}
                              onChange={(e) =>
                                handleSelectAllPermissionChange("test_evaluation_permission", e.target.checked)
                              }
                            />
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>

                {/* Submit Button */}
                <div className="d-flex align-items-center justify-content-center">
                  <button
                    type="button"
                    className="btn btn-primary me-3"
                    onClick={() => handleSubmit()}
                    disabled={isSubmitLoading}
                  >
                    {isSubmitLoading ? "Submitting..." : "Submit"}
                  </button>

                  <button
                    type="button"
                    className="btn btn-secondary"
                    onClick={handleCancel}
                  >
                    Cancel
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddUser;